import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
declare var $: any;

@Component({
    selector: 'ea-dropdown',
    templateUrl: './ea-dropdown.component.html',
    styleUrls: ['./ea-dropdown.component.scss'],
    standalone: false
})
export class EaDropdownComponent implements OnInit {
  @Input() buttons: any;
  @Input() iconWidth: any;
  @Input() iconHorizontal: boolean = true;
  @Input() alignRight: boolean = true;
  @Input() noOffset: boolean = false;
  @Output() buttonPressed = new EventEmitter();
  @ViewChild('dropdown', { static: true }) dropdownElem: ElementRef;
  dropdown: any;
  closeTimeout: any;

  constructor() {
    if (!this.iconWidth) this.iconWidth = '24px';
  }

  ngOnInit() {
    this.dropdown = this.dropdownElem.nativeElement;
  }

  onButtonPressed(item) {
    this.buttonPressed.emit(item);
  }

  openDropdown() {
    this.dropdown.classList.add('open');
  }

  cancelTimeout() {
    clearTimeout(this.closeTimeout);
  }

  triggerOut() {
    this.closeTimeout = setTimeout(() => {
      this.dropdown.classList.remove('open');
    }, 1000);
  }
}
